// index

let dt_providers = null;

export function index(){
    
    dt_providers = $('#providers_table').DataTable({
        ajax: {
            url: $('#providers_table').attr('url'),
        },
        columns: [
            { width: '20', data: null, orderable: false, searchable: false, class: 'actions', render: render_import_actions },
            { data: 'name', orderable: true, searchable: true },
            { width: '100', data: 'references_count', orderable: false, searchable: false, class: 'text-right', defaultContent: '' },
            { width: '150', data: 'last_offer', orderable: true, searchable: false, render: datatables.render_date, defaultContent: '' },
        ],
        order: [[1, 'asc']],
        pageLength: 50,
    });
    
}

function render_import_actions(data, type, row){
    const url_info = ($("#providers_table").attr('url_info') ?? '').replace('#', row.id);
    
    const actions = 
    '<div class="btn-group" role="group">' +
    '   <a class="btn btn-primary btn-xs show ajax" href="' + url_info + '">' + window.__('info') + '</a>' +
    '</div>';
    
    return actions;
}

// show

let dt_offers = null;
let dt_references = null;

export function show(){

    dt_offers = $('#offers_table').DataTable({
        ajax: {
            url: $('#offers_table').attr('url'),
        },
        columns: [
            { width: '20', data: null, orderable: false, searchable: false, class: 'actions', render: render_offer_actions },
            { width: '80', data: 'date', orderable: true, searchable: false, render: datatables.render_date },
            { data: 'filename', orderable: true, searchable: true },
            { width: '80', data: 'status', orderable: false, searchable: false, defaultContent: '', render: render_offer_status },
            { width: '120', data: 'updated_at', orderable: true, searchable: false, render: datatables.render_datetime }
        ],
        order: [[1, 'desc']],
        pageLength: 50,
    });

    dt_references = $('#references_table').DataTable({
        ajax: {
            url: $('#references_table').attr('url'),
        },
        select: {
            style: 'multi+shift',
        },
        columns: [
            { width: '20', data: 'id', orderable: false, searchable: false, checkboxes: { selectRow: true } },
            { width: '20', data: null, orderable: false, searchable: false, class: 'actions', render: render_reference_actions },
            { width: '120', data: 'ean', orderable: true, searchable: true },
            { data: 'name', orderable: true, searchable: true },
            { width: '120', data: 'last_offer_0', orderable: false, searchable: false, class: 'text-right', render: render_last_offer(0), defaultContent: '' },
            { width: '70', data: 'last_offer_1', orderable: false, searchable: false, class: 'text-right', render: render_last_offer(1), defaultContent: '' },
            { width: '70', data: 'last_offer_2', orderable: false, searchable: false, class: 'text-right', render: render_last_offer(2), defaultContent: '' },
            { width: '70', data: 'last_offer_3', orderable: false, searchable: false, class: 'text-right', render: render_last_offer(3), defaultContent: '' },
            { width: '70', data: 'last_offer_4', orderable: false, searchable: false, class: 'text-right', render: render_last_offer(4), defaultContent: '' },
        ],
        order: [[3, 'asc']],
        pageLength: 50,
    });

    // Add event handlers for batch actions
    dt_references.on('init', function(e, settings, json){
        $(settings.nTableWrapper).find('.table_batch_actions [action="add_categories"]').click(batch_add_categories);
        $(settings.nTableWrapper).find('.table_batch_actions [action="remove_categories"]').click(batch_remove_categories);
    });

}

function render_offer_actions(data, type, row){
    const url_info = ($("#offers_table").attr('url_info') ?? '').replace('#', row.id);

    const actions = 
        '<div class="btn-group" role="group">' +
        '   <a class="btn btn-primary btn-xs show ajax" href="' + url_info + '">' + window.__('info') + '</a>' +
        '</div>';

    return actions;
}

function render_offer_status(data, type, row){

    switch(row.status){
        case 'analysis':
            return '<span class="badge bg-light">' + window.__('analizando') + '</span>';
        case 'creating':
            return '<span class="badge bg-light">' + window.__('preparación') + '</span>';
        case 'pending':
            return '<span class="badge bg-info">' + window.__('pendiente') + '</span>';
        case 'processing':
            return '<span class="badge bg-primary">' + window.__('en proceso') + '</span>';
        case 'completed':
            return '<span class="badge bg-success">' + window.__('completado') + '</span>';
        case 'failed':
            return '<span class="badge bg-danger">' + window.__('error') + '</span>';
    }

    return row.status + ' ???'; // unrecognized status

}

let render_last_offer = function(index){
    return function(data, type, row){

        let offer = row.last_offers[index] ?? null;
        if(offer === null){
            return '-';
        }

        let price = new Intl.NumberFormat(window._locale, {
            style: 'currency',
            currency: 'EUR',
            minimumFractionDigits: 3,
            maximumFractionDigits: 3,
            useGrouping: true
        }).format(offer.price);

        let date = moment(offer.date).format('DD/MM/YY');
        return price + '<br/><small class="text-muted">' + date + '</small>';

    }
}

// create_offer

export function create_offer(){

    // Update exchange rate when currency changes
    $('select[name="currency"]').on('change', function(){
        const exchange_rate = $('select[name="currency"] option:selected').attr('exchange_rate') ?? 1;
        $('input[name="exchange_rate"]').val(exchange_rate);
    });

}

// match_columns

export function match_columns(){

    // Update exchange rate when currency changes
    $('select[name="currency"]').on('change', function(){
        const exchange_rate = $('select[name="currency"] option:selected').attr('exchange_rate') ?? 1;
        $('input[name="exchange_rate"]').val(exchange_rate);
    });

    // Enable/disable sheet configuration according to checkbox
    $('#match_columns_form').on('submit', validate_match_columns_form);

    // Highlight header and first row
    $('input.first-row').on('change', highlight_first_row).trigger('change');
    $('input.header-row').on('change', highlight_header_row).trigger('change');

    let status = $('#offer_status').length ? $('#offer_status').attr('status') : null;
    if(status == 'analysis'){
        setInterval(function(){
            $.ajax({
                url: $('#offer_status').attr('url'),
                method: 'GET',
                success: function(response){
                    if(response.status != status){
                        location.reload();
                    }
                }
            });
        }, 5000);
    }

}

function validate_match_columns_form(e){
    e.preventDefault();

    let valid = true;

    if($('.sheet:checked').length == 0){
        window.messages.error(window.__('Debe seleccionar al menos una hoja para importar'));
        return false;
    }

    $('.sheet:checked').each(function(){

        const sheetIndex = $(this).attr('name').replace('sheet_', '');
        const sheetName = $(this).closest('.tab-pane').attr('sheet-name');

        const header_row = parseInt($('#sheet_' + sheetIndex + ' input[name="sheet_' + sheetIndex + '_header_row"]').val());
        const first_row = parseInt($('#sheet_' + sheetIndex + ' input[name="sheet_' + sheetIndex + '_first_row"]').val());

        if(header_row >= first_row){
            window.messages.error(window.__('La línea del primer producto debe ser mayor que la línea del encabezado de la hoja :sheet', { sheet: sheetName }));
            valid = false;
            return false; // break loop
        }

        const ean_columns = $('#sheet_' + sheetIndex + ' option[value="ean"]:selected').length;
        if(ean_columns == 0){
            window.messages.error(window.__('Debes seleccionar una columna para el código EAN en la hoja :sheet', { sheet: sheetName }));
            valid = false;
            return false; // break loop
        }

        if(ean_columns > 1){
            window.messages.error(window.__('Sólo se puede asignar una columna para el código EAN en la hoja :sheet', { sheet: sheetName }));
            valid = false;
            return false; // break loop
        }

        const name_columns = $('#sheet_' + sheetIndex + ' option[value="name"]:selected').length;
        if(name_columns == 0){
            window.messages.error(window.__('Debes seleccionar una columna para el nombre de producto en la hoja :sheet', { sheet: sheetName }));
            valid = false;
            return false; // break loop
        }

        if(name_columns > 1){
            window.messages.error(window.__('Sólo se puede asignar una columna para el nombre de producto en la hoja :sheet', { sheet: sheetName }));
            valid = false;
            return false; // break loop
        }

        const price_columns = $('#sheet_' + sheetIndex + ' option[value="price"]:selected').length;
        if(price_columns == 0){
            window.messages.error(window.__('Debes seleccionar una columna para el precio en la hoja :sheet', { sheet: sheetName }));
            valid = false;
            return false; // break loop
        }

    });

    return valid ? e.currentTarget.submit() : false;

}

function highlight_header_row(){
    
    const sheetIndex = $(this).attr('name').replace('sheet_', '').replace('_header_row', '');
    const header_row = parseInt($(this).val());

    $('#sheet_' + sheetIndex + ' .cell').removeClass('bg-primary-light');
    $('#sheet_' + sheetIndex + ' .cell.row_' + header_row).addClass('bg-primary-light');

}

function highlight_first_row(){
    
    const sheetIndex = $(this).attr('name').replace('sheet_', '').replace('_first_row', '');
    const first_row = parseInt($(this).val());

    $('#sheet_' + sheetIndex + ' .cell').removeClass('bg-success-light');
    for(let i = first_row; i <= 20; i++){
        $('#sheet_' + sheetIndex + ' .cell.row_' + i).addClass('bg-success-light');
    }

}

// show_offer

let dt_import_results = null;

export function show_offer(){

    // datatable logs
    
    dt_import_results = $('#import_results_table').DataTable({
        ajax: {
            url: $('#import_results_table').attr('url'),
        },
        columns: [
            { width: 50, data: 'row', orderable: true, searchable: true },
            { width: 120, data: 'ean', orderable: false, searchable: true, defaultContent: '' },
            { data: 'status', orderable: false, searchable: false, defaultContent: '', render: render_import_result_status },
        ],
        order: [[0, 'asc']],
    });

    let status = $('#offer_status').length ? $('#offer_status').attr('status') : null;
    if(
        status == 'pending' 
        || status == 'processing'
    ){
        setInterval(function(){
            $.ajax({
                url: $('#offer_status').attr('url'),
                method: 'GET',
                success: function(response){
                    if(response.status != status){
                        location.reload();
                    }
                }
            });
        }, 5000);
    }

}

function render_import_result_status(data, type, row){

    let status = row.status.split(',');
    let badges = '';

    status.forEach(s => {
        switch(s.trim()){
            case 'reference_created':
                badges += '<span class="badge bg-success me-1 mr-1">' + window.__('referencia creada') + '</span>';
                break;
            case 'offer_created':
                badges += '<span class="badge bg-success me-1 mr-1">' + window.__('oferta creada') + '</span>';
                break;
            case 'invalid_ean':
                badges += '<span class="badge bg-warning me-1 mr-1">' + window.__('código no válido') + '</span>';
                break;
            case 'exception':
                badges += '<span class="badge bg-danger me-1 mr-1">' + window.__('error') + ': ' + row.exception + '</span>';
                break;
            case 'skipped':
                badges += '<span class="badge bg-light me-1 mr-1">' + window.__('no procesada: linea incompleta') + '</span>';
                break;
        } 
    });

    return badges;

}

function render_reference_actions(data, type, row){
    const url_info = $("#references_table").attr('url_info') ?? '';
    if(url_info === '') return '';
    
    const info_url = url_info.replace('#', row.id);
    
    const actions = 
    '<div class="btn-group" role="group">' +
    '   <a class="btn btn-primary btn-xs show ajax" href="' + info_url + '">' + window.__('info') + '</a>' +
    '</div>';
    
    return actions;
}

function batch_add_categories(){
    const table = $(this).closest('.dataTables_wrapper').find('.dataTable').DataTable();
    const rows_selected = table.column(0).checkboxes.selected();
    
    let references_id = [];
    $.each(rows_selected, function(index, rowId){
        references_id.push(rowId);
    });
    
    if(references_id.length == 0){
        window.messages.error(__('No has seleccionado ninguna referencia'));
    } else {
        $('#add-categories-modal input[name="reference_ids"]').val(references_id.join(','));
        $('#add-categories-modal select[name="category_ids[]"]').val(null).trigger('change');
        $('#add-categories-modal').modal('show');
    }
}

function batch_remove_categories(){
    const table = $(this).closest('.dataTables_wrapper').find('.dataTable').DataTable();
    const rows_selected = table.column(0).checkboxes.selected();
    
    let references_id = [];
    $.each(rows_selected, function(index, rowId){
        references_id.push(rowId);
    });
    
    if(references_id.length == 0){
        window.messages.error(__('No has seleccionado ninguna referencia'));
    } else {
        $('#remove-categories-modal input[name="reference_ids"]').val(references_id.join(','));
        $('#remove-categories-modal select[name="category_ids[]"]').val(null).trigger('change');
        $('#remove-categories-modal').modal('show');
    }
}

export function updated_categories_reload(){
    $('#add-categories-modal').modal('hide');
    $('#remove-categories-modal').modal('hide');
    dt_references.ajax.reload();
}

let dt_manual_offer_references = null;
let dt_manual_offer_references_data = [];
let dt_manual_offer_references_index = 0;

export function create_manual_offer(){

    dt_manual_offer_references_data = [];

    dt_manual_offer_references = $('#manual_offer_references_table').DataTable({
        processing: false,
        serverSide: false,
        stateSave: false,
        ajax: null,                            
        data: dt_manual_offer_references_data, 
        columns: [
            { width: '20', data: 'index', orderable: false, searchable: false, class: 'actions', render: render_create_manual_offer_reference_actions },
            { data: 'ean', orderable: true, searchable: false },
            { data: 'name', orderable: false, searchable: false },
            { data: 'price', orderable: false, searchable: false },
            { data: 'stock', orderable: false, searchable: false },
            { data: 'units_per_box', orderable: false, searchable: false },
            { data: 'units_per_pallet', orderable: false, searchable: false },
            { data: 'boxes_per_pallet', orderable: false, searchable: false },
            { data: 'min_order', orderable: false, searchable: false },
            { data: 'max_order', orderable: false, searchable: false },
            { data: 'expiration', orderable: false, searchable: false },
            { data: 'language', orderable: false, searchable: false },
        ],
        order: [[1, 'asc']],
        pageLength: 50,
    });

    dt_manual_offer_references.on('init.dt', function(e, settings, json){
        $('#manual_offer_references_table_length').closest('.row').hide();
        $('#manual_offer_references_table_paginate').hide();

        $('#reference_form').on('submit', function(e){
            e.preventDefault();

            // validar
            let ean = $('#reference_form input[name="ean"]').val().replace(/[^0-9]/g, '');
            $('#reference_form input[name="ean"]').val(ean);
            if(ean === ''){
                window.messages.error(window.__('El código EAN13 es obligatorio'));
                return false;
            }

            let name = $('#reference_form input[name="name"]').val().trim();
            $('#reference_form input[name="name"]').val(name);
            if(name === ''){
                window.messages.error(window.__('El nombre es obligatorio'));
                return false;
            }

            let price = parseFloat($('#reference_form input[name="price"]').val());
            $('#reference_form input[name="price"]').val(price.toFixed(3));
            if(isNaN(price) || price < 0){
                window.messages.error(window.__('El precio debe ser un número mayor o igual a cero'));
                return false;
            }

            let stock = $('#reference_form input[name="stock"]').val().trim();
            $('#reference_form input[name="stock"]').val(stock);
            if(stock != ''){
                stock = parseInt(stock);
                $('#reference_form input[name="stock"]').val(stock);
                if(isNaN(stock) || stock < 0){
                    window.messages.error(window.__('El stock debe ser un número entero mayor o igual a cero'));
                    return false;
                }
            }

            let units_per_box = $('#reference_form input[name="units_per_box"]').val().trim();
            $('#reference_form input[name="units_per_box"]').val(units_per_box);
            if(units_per_box != ''){
                units_per_box = parseInt(units_per_box);
                $('#reference_form input[name="units_per_box"]').val(units_per_box);
                if(isNaN(units_per_box) || units_per_box < 0){
                    window.messages.error(window.__('Las unidades por caja deben ser un número entero mayor o igual a cero'));
                    return false;
                }
            }

            let units_per_pallet = $('#reference_form input[name="units_per_pallet"]').val().trim();
            $('#reference_form input[name="units_per_pallet"]').val(units_per_pallet);
            if(units_per_pallet != ''){
                units_per_pallet = parseInt(units_per_pallet);
                $('#reference_form input[name="units_per_pallet"]').val(units_per_pallet);
                if(isNaN(units_per_pallet) || units_per_pallet < 0){
                    window.messages.error(window.__('Las unidades por pallet deben ser un número entero mayor o igual a cero'));
                    return false;
                }
            }

            let boxes_per_pallet = $('#reference_form input[name="boxes_per_pallet"]').val().trim();
            $('#reference_form input[name="boxes_per_pallet"]').val(boxes_per_pallet);
            if(boxes_per_pallet != ''){
                boxes_per_pallet = parseInt(boxes_per_pallet);
                $('#reference_form input[name="boxes_per_pallet"]').val(boxes_per_pallet);
                if(isNaN(boxes_per_pallet) || boxes_per_pallet < 0){
                    window.messages.error(window.__('Las cajas por pallet deben ser un número entero mayor o igual a cero'));
                    return false;
                }
            }

            let min_order = $('#reference_form input[name="min_order"]').val().trim();
            $('#reference_form input[name="min_order"]').val(min_order);
            if(min_order != ''){
                min_order = parseInt(min_order);
                $('#reference_form input[name="min_order"]').val(min_order);
                if(isNaN(min_order) || min_order < 0){
                    window.messages.error(window.__('El pedido mínimo debe ser un número entero mayor o igual a cero'));
                    return false;
                }
            }

            let max_order = $('#reference_form input[name="max_order"]').val().trim();
            $('#reference_form input[name="max_order"]').val(max_order);
            if(max_order != ''){
                max_order = parseInt(max_order);
                $('#reference_form input[name="max_order"]').val(max_order);
                if(isNaN(max_order) || max_order < 0){
                    window.messages.error(window.__('El pedido máximo debe ser un número entero mayor o igual a cero'));
                    return false;
                }
            }

            if($('#reference_form input[name="index"]').val() == ''){
            
                let reference = {
                    index: dt_manual_offer_references_index++,
                    ean: ean,
                    name: name,
                    price: price,
                    stock: stock,
                    units_per_box: units_per_box,
                    units_per_pallet: units_per_pallet,
                    boxes_per_pallet: boxes_per_pallet,
                    min_order: min_order,
                    max_order: max_order,
                    expiration: $('#reference_form input[name="expiration"]').val().trim(),
                    language: $('#reference_form input[name="language"]').val().trim(),
                };

                dt_manual_offer_references_data.push(reference);

            } else {

                let index = parseInt($('#reference_form input[name="index"]').val());
                let reference = dt_manual_offer_references_data.find(reference => reference.index === index);
                if(reference){
                    reference.ean = ean;
                    reference.name = name;
                    reference.price = price;
                    reference.stock = stock;
                    reference.units_per_box = units_per_box;
                    reference.units_per_pallet = units_per_pallet;
                    reference.boxes_per_pallet = boxes_per_pallet;
                    reference.min_order = min_order;
                    reference.max_order = max_order;
                    reference.expiration = $('#reference_form input[name="expiration"]').val().trim();
                    reference.language = $('#reference_form input[name="language"]').val().trim();
                }

            }

            $('input[name="references"]').val(JSON.stringify(dt_manual_offer_references_data));
            dt_manual_offer_references.clear().rows.add(dt_manual_offer_references_data).draw();
            $('#reference_modal').modal('hide');
        });
    });

    dt_manual_offer_references.on('draw.dt', function(e, settings, json){
        $('#manual_offer_references_table_info').html('<button type="button" class="btn btn-primary btn-sm" id="add_reference_button">' + window.__('Añadir referencia') + '</button>');

        $('#add_reference_button').on('click', function(){
            $('#reference_form').trigger('reset');
            $('#reference_form input[name="index"]').val('');
            $('#reference_form button[type="submit"]').html(window.__('Añadir referencia'));
            $('#reference_modal').modal('show');
        });

        $('#manual_offer_references_table .btn.edit').on('click', function(){
            const row_index = $(this).attr('index');
            const reference = dt_manual_offer_references_data.find(reference => reference.index === parseInt(row_index));
            if(reference){
                $('#reference_form input[name="index"]').val(reference.index);
                $('#reference_form input[name="ean"]').val(reference.ean);
                $('#reference_form input[name="name"]').val(reference.name);
                $('#reference_form input[name="price"]').val(reference.price);
                $('#reference_form input[name="stock"]').val(reference.stock);
                $('#reference_form input[name="units_per_box"]').val(reference.units_per_box);
                $('#reference_form input[name="units_per_pallet"]').val(reference.units_per_pallet);
                $('#reference_form input[name="boxes_per_pallet"]').val(reference.boxes_per_pallet);
                $('#reference_form input[name="min_order"]').val(reference.min_order);
                $('#reference_form input[name="max_order"]').val(reference.max_order);
                $('#reference_form input[name="expiration"]').val(reference.expiration);
                $('#reference_form input[name="language"]').val(reference.language);
                $('#reference_form button[type="submit"]').html(window.__('Actualizar referencia'));
                $('#reference_modal').modal('show');
            }
        });

        $('#manual_offer_references_table .btn.delete').on('click', function(){
            const row_index = $(this).attr('index');
            dt_manual_offer_references_data = dt_manual_offer_references_data.filter(reference => reference.index !== parseInt(row_index));
            dt_manual_offer_references.clear().rows.add(dt_manual_offer_references_data).draw();
        });
    });

}

function render_create_manual_offer_reference_actions(data, type, row){
    
    const actions = 
    '<div class="btn-group" role="group">' +
    '   <a class="btn btn-primary btn-xs edit" index="' + row.index + '">' + window.__('editar') + '</a>' +
    '   <a class="btn btn-danger btn-xs delete" index="' + row.index + '">' + window.__('eliminar') + '</a>' +
    '</div>';
    
    return actions;
}